import {makeAutoObservable} from "mobx";

const navbarLocalStorageKey = 'navbar-expanded'

class AppStore {
    get expanded(): boolean {
        return this._expanded;
    }

    set expanded(value: boolean) {
        this._expanded = value;
        localStorage.setItem(navbarLocalStorageKey, JSON.stringify(value))
    }
    private _expanded: boolean = false
    constructor() {
        makeAutoObservable(this)

        const navbarExpanded = localStorage.getItem(navbarLocalStorageKey)
        if (navbarExpanded !== null) {
            this.expanded = JSON.parse(navbarExpanded) as boolean
        }
    }
}

const appStore = new AppStore()

export {
    appStore
}
